module.exports = __webpack_public_path__ + "media/images/application/template/icon--download-466f31ae5c4b5663f12b842197c43d1b.svg";